/**
 * 单位换算模块 - 枚举定义
 * 
 * @module types/unit-conversion/enums
 * @description 定义单位换算相关的枚举类型
 * 
 * 数据来源：
 * - backend/app/Modules/Material/Models/MaterialUnit.php (常量定义)
 * 
 * 注意事项：
 * - 枚举值必须与后端完全一致（包括大小写）
 * - 每个枚举值都有中文注释说明其含义
 * 
 * @last-updated 2025-10-19
 */

/**
 * 单位类型
 * @description 物料单位的分类类型
 */
export enum UnitType {
  /** 基本单位 */
  BASE = 'BASE',
  /** 采购单位 */
  PURCHASE = 'PURCHASE',
  /** 生产单位 */
  PRODUCTION = 'PRODUCTION',
}

/**
 * 常用单位代码
 * @description 系统预定义的常用单位
 */
export enum CommonUnit {
  /** 个 */
  PCS = 'PCS',
  /** 箱 */
  BOX = 'BOX',
  /** 盘 */
  REEL = 'REEL',
  /** 千克 */
  KG = 'KG',
  /** 吨 */
  T = 'T',
  /** 克 */
  G = 'G',
  /** 升 */
  L = 'L',
  /** 毫升 */
  ML = 'ML',
  /** 米 */
  M = 'M',
  /** 平方米 */
  M2 = 'M2',
  /** 立方米 */
  M3 = 'M3',
}

/**
 * 单位状态
 * @description 单位的启用/停用状态
 */
export enum UnitStatus {
  /** 停用 */
  INACTIVE = 0,
  /** 启用 */
  ACTIVE = 1,
}

